import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
import { fg } from '@atlaskit/platform-feature-flags';
import { N0, N20, N30A, N700 } from '@atlaskit/theme/colors';
import { contextualMenuTriggerSize } from '../consts';
export var tableFloatingCellButtonStyles = function tableFloatingCellButtonStyles() {
  return css({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> div': _objectSpread({
      // Sits behind button to provide surface-color background
      background: "var(--ds-surface, ".concat(N20, ")"),
      borderRadius: "var(--ds-radius-small, 3px)",
      display: 'flex',
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
      height: "".concat(contextualMenuTriggerSize + 2, "px"),
      flexDirection: 'column'
    }, fg('platform-visual-refresh-icons') && {
      width: "var(--ds-space-250, 20px)"
    }),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&& button': {
      background: "var(--ds-background-neutral, none)",
      flexDirection: 'column',
      margin: "var(--ds-space-025, 2px)",
      outline: "2px solid ".concat("var(--ds-surface, ".concat(N0, ")")),
      borderRadius: '1px',
      padding: 0,
      height: 'calc(100% - 4px)',
      display: 'flex'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&& button:hover': {
      background: "var(--ds-background-neutral-hovered, ".concat(N30A, ")")
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&& button:active': {
      background: "var(--ds-background-neutral-pressed, rgba(179, 212, 255, 0.6))"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&& button > span': {
      margin: "0px ".concat("var(--ds-space-negative-050, -4px)")
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&& span': {
      pointerEvents: 'none'
    }
  });
};
export var tableFloatingCellButtonSelectedStyles = function tableFloatingCellButtonSelectedStyles() {
  return css({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&& button': {
      background: "var(--ds-background-selected, ".concat(N700, ")")
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&& button:hover': {
      background: "var(--ds-background-selected-hovered, ".concat(N700, ")")
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&& button:active': {
      background: "var(--ds-background-selected-pressed, ".concat(N700, ")")
    }
  });
};